import { cn } from '@utils/cn';

interface CategoryCardProps {
  id: string;
  name: string;
  image: string;
  isSelected: boolean;
  onClick: () => void;
}

const CategoryCard = ({
  id,
  name,
  image,
  isSelected,
  onClick,
}: CategoryCardProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'relative flex flex-col items-center justify-between h-32 md:h-40 min-w-[110px] md:min-w-[130px] px-3 md:px-4 py-3 md:py-4 rounded-2xl transition-all duration-300 transform',
        'hover:scale-105 hover:z-10 focus:outline-none focus:ring-4 focus:ring-primary/20',
        isSelected
          ? 'bg-gradient-primary text-white shadow-premium z-10'
          : 'bg-white text-gray-700 border-2 border-gray-200 hover:border-primary hover:ring-2 hover:ring-primary/30 hover:shadow-lg'
      )}
      aria-label={`Select ${name} category`}
    >
      <div
        className={cn(
          'w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden shadow-lg transition-transform duration-300 flex-shrink-0',
          isSelected && 'ring-2 ring-white/50'
        )}
      >
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            if (target.src !== 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=500&auto=format&fit=crop') {
              target.src = 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=500&auto=format&fit=crop';
            }
          }}
        />
      </div>

      <span
        className={cn(
          'text-xs md:text-sm font-semibold text-center whitespace-nowrap transition-colors mt-auto',
          isSelected ? 'text-white' : 'text-gray-900'
        )}
      >
        {name}
      </span>
    </button>
  );
};

export default CategoryCard;
